var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAbcPoint(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12592_100761)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 40C31 40 40 31 40 20C40 9 31 0 20 0C9 0 0 9 0 20C0 31 9 40 20 40Z",
    fill: "url(#paint0_linear_12592_100761)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0511 22.9496C17.3192 24.2171 19.0692 25.002 20.9999 25.002V21.3116C20.0869 21.3116 19.2591 20.9405 18.6596 20.3405L15.7119 16.7578",
    fill: "url(#paint1_linear_12592_100761)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M16.0518 22.9487C17.3199 24.2162 19.0699 25.0018 21.0005 25.0012V21.3107C20.0875 21.3107 19.2597 20.9397 18.6602 20.3396L16.6861 17.9399",
    fill: "url(#paint2_linear_12592_100761)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.948 14.309C26.9199 14.2649 26.8911 14.2208 26.8623 14.1779L26.8617 14.1791C25.8073 12.5675 24.1075 11.4139 22.1316 11.0912C22.1285 11.0912 22.1248 11.09 22.1218 11.0894C21.9791 11.0661 21.8352 11.0478 21.6901 11.0337C21.6791 11.0325 21.6674 11.0318 21.6558 11.0306C21.5988 11.0251 21.5425 11.0208 21.485 11.0165C21.4641 11.0153 21.4433 11.0141 21.4225 11.0129C21.3723 11.0098 21.3221 11.0073 21.2719 11.0055C21.251 11.0049 21.2302 11.0037 21.2088 11.0031C21.1402 11.0012 21.0716 11 21.0024 11H21C17.8643 11 15.2032 13.0733 14.3147 15.9206C14.1108 16.5776 14.0012 17.275 14.0012 17.9988C14.0012 18.068 14.0024 18.1365 14.0043 18.2051H14.0031H14L14 27.9896C14 27.9896 14.1298 28.0006 14.3404 28C15.254 27.9982 17.6898 27.7826 17.6898 25.5342V24.166V19.1603C17.6898 19.1603 17.6898 18.8872 17.6898 18.6056V18C17.6898 17.8286 17.7027 17.6602 17.7284 17.4955C17.9709 15.9065 19.3437 14.688 21.0006 14.688C22.4726 14.688 23.7199 15.6499 24.1498 16.9787C24.2545 17.3007 24.3114 17.6436 24.3114 18C24.3114 18.913 23.9397 19.7408 23.3403 20.3403C22.7408 20.9397 21.9136 21.3114 21.0006 21.3114V24.9976C22.2669 24.9976 23.4548 24.6614 24.4792 24.073C24.4822 24.0711 24.4853 24.0699 24.4878 24.0681C24.5312 24.043 24.5747 24.0172 24.6176 23.9909C24.631 23.9829 24.6445 23.9744 24.658 23.9658C24.6947 23.9431 24.7321 23.9205 24.7688 23.8966C24.8178 23.8654 24.8662 23.8335 24.9145 23.8011C24.9292 23.7913 24.9439 23.7809 24.9586 23.7705C25.0003 23.7417 25.0419 23.7129 25.0829 23.6829C25.0958 23.6737 25.108 23.6645 25.1209 23.6554C25.1674 23.6217 25.2133 23.5874 25.2587 23.5525C25.2648 23.5482 25.2703 23.5433 25.2764 23.539C25.893 23.062 26.4276 22.484 26.8568 21.8307C27.5787 20.7297 27.9994 19.4126 27.9994 17.9976C27.9994 16.5825 27.6142 15.3793 26.9487 14.3077L26.948 14.309Z",
    fill: "url(#paint3_linear_12592_100761)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M31.3136 31.3137C29.8278 32.7994 28.064 33.978 26.1228 34.7821C24.1816 35.5861 22.101 36 19.9999 36C17.8987 36 15.8181 35.5861 13.8769 34.7821C11.9357 33.978 10.1719 32.7994 8.68616 31.3137C7.20042 29.828 6.02187 28.0641 5.2178 26.1229C4.41372 24.1817 3.99987 22.1011 3.99987 20C3.99987 17.8988 4.41372 15.8183 5.2178 13.8771",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8.68643 8.6863C10.1722 7.20056 11.936 6.02201 13.8772 5.21794C15.8184 4.41386 17.899 4.00001 20.0001 4.00001C22.1013 4.00001 24.1819 4.41386 26.1231 5.21794C28.0643 6.02202 29.8281 7.20057 31.3138 8.6863C32.7996 10.172 33.9781 11.9359 34.7822 13.8771C35.5863 15.8183 36.0001 17.8989 36.0001 20C36.0001 22.1012 35.5863 24.1817 34.7822 26.1229",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12592_100761",
    x1: 0,
    y1: 20,
    x2: 40,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00641811,
    stopColor: "#FF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCC00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_12592_100761",
    x1: 11.7784,
    y1: 20.8799,
    x2: 27.9129,
    y2: 20.8799,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D2D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_12592_100761",
    x1: 4.6737,
    y1: 21.4712,
    x2: 20.9172,
    y2: 21.4712,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#666666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#666666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_12592_100761",
    x1: -2.1676,
    y1: 19.4769,
    x2: 38.3684,
    y2: 19.4769,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D2D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12592_100761"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbcPoint);
export default __webpack_public_path__ + "static/media/ABCPoint.5e689d25eaf2e9c67f219ad3d79adf3f.svg";
export { ForwardRef as ReactComponent };